var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tag-badge-info"},[_c('span',{staticClass:"tag-badge-title-info pl-3"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"dropdown-divider mt-0 pb-2 ml-3 w-100"})])
}
var staticRenderFns = []

export { render, staticRenderFns }